/* Kleine Linien-Icons (18 px), aria-hidden: Die Bedeutung trägt immer der Text daneben. */
const PFADE = {
  woche: "M4 5h16v15H4zM4 9h16M9 3v4M15 3v4",
  liste: "M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01",
  offen: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 8v5M12 16h.01",
  sprint: "M4 12a8 8 0 0 1 14-5.3M20 12a8 8 0 0 1-14 5.3M18 3v4h-4M6 21v-4h4",
  termine: "M4 5h16v15H4zM4 9h16M8 13h3M8 16h3",
  sitzung: "M4 19h16M6 19v-6h12v6M12 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
  protokolle: "M6 3h9l3 3v15H6zM9 10h6M9 14h6M9 18h4",
  ablage: "M3 6h7l2 2h9v11H3z",
  newsletter: "M3 6h18v12H3zM3 7l9 6 9-6",
  website: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18",
  zugaenge: "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM2 21c0-4 3-6 7-6s7 2 7 6M17 8l2 2 4-4",
  veranstaltung: "M4 5h16v15H4zM4 9h16M9 3v4M15 3v4M12 12l1.2 2.3 2.5.4-1.8 1.8.4 2.5-2.3-1.2-2.3 1.2.4-2.5-1.8-1.8 2.5-.4z",
  partner: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1",
  vorstandsseite: "M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM16 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM2 20c0-3 3-5 6-5s6 2 6 5M16 15c3 0 6 2 6 5",
  mission: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zM12 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
  glocke: "M6 16V11a6 6 0 1 1 12 0v5l2 2H4zM10 20a2 2 0 0 0 4 0",
  plus: "M12 5v14M5 12h14",
  mehr: "M4 7h16M4 12h16M4 17h16",
  abmelden: "M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10",
  person: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21c0-4 4-6 8-6s8 2 8 6",
  vorhaben: "M12 3l9 5-9 5-9-5zM3 13l9 5 9-5",
  uhr: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 7v5l3 2",
  schliessen: "M6 6l12 12M18 6L6 18",
} as const;

export type IconName = keyof typeof PFADE;

export function Icon({ name, groesse = 18 }: { name: IconName; groesse?: number }) {
  return (
    <svg width={groesse} height={groesse} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d={PFADE[name]} />
    </svg>
  );
}
